import React, { Component } from "react";
import LayoutBase from "./layout-base";

// This is a direct copy of layout-global with the .uk-container-xlarge class added to widen the container
export default class WideLayout extends Component {
  render() {
    return (
      <LayoutBase location={this.props.location}>
        <main className="uk-container uk-container-xlarge" id="contentContainer">
          {this.props.children}
        </main>
      </LayoutBase>
    );
  }
}
